import React from "react";
import { Paper, PaperProps } from "@mui/material";
import styled from "@emotion/styled";
import { Loader } from "./Loader";

const BasePaper = (props: PaperProps) => {
  return (
    <Paper {...props}>
      <Loader>{props.children}</Loader>
    </Paper>
  );
};

export const StyledPaper: React.ComponentType<PaperProps> = styled(BasePaper)`
  margin-bottom: 1rem;
  max-width: calc(100vw - 64px);

  @media (min-width: 600px) {
    max-width: calc(100vw - 100px);
  }

  @media (min-width: 900px) {
    max-width: calc(100vw - 340px);
  }
`;
